import CustomButton from "components/CustomButton/CustomButton";
import { ACTION_TYPES } from "./utils/constants";
import SpaceDialogAction from "./SpaceDialogAction";
import { Column } from "components/styles";

const DialogNotActionForHaveAttendanceOrPenalty = ({
	dialog, actionTypeOfNoActionForHaveAttendanceOrPenalty,
	studentsWithRegisteredPenalty,
	studentsWithPenaltyOrAttendanceForDeletion
}) => {
	if (!actionTypeOfNoActionForHaveAttendanceOrPenalty.value) return null;
	const props = ({
		[ACTION_TYPES.PENALIZE]: {
			title: "No se puede sancionar a todos los alumnos",
			subtitle: "Actualmente cuentan con una sanción registrada:",
			students: studentsWithRegisteredPenalty
		},
		[ACTION_TYPES.DELETE]: {
			title: "No se puede eliminar a todos los alumnos",
			subtitle: "Actualmente cuentan con asistencia o sanción:",
			students: studentsWithPenaltyOrAttendanceForDeletion
		}
	})[actionTypeOfNoActionForHaveAttendanceOrPenalty.value];
	return (
		<SpaceDialogAction
			dialog={dialog}
			title={props.title}
			contentComponent={
				<>
					<p className="paragraph center">{props.subtitle}</p>
					<Column className="custom-scrollbar secondary"
						maxHeight="150px"
						align="center">
						<ul className="list paragraph center">
							{props.students
								.map(({ id, name }) => (
									<li key={id}>{id} ({name})</li>
								))}
						</ul>
					</Column>
				</>
			}>
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogNotActionForHaveAttendanceOrPenalty;